import { render } from "./import-tradeindia.vue?vue&type=template&id=7f33a994&scoped=true"
import script from "./import-tradeindia.vue?vue&type=script&lang=js"
export * from "./import-tradeindia.vue?vue&type=script&lang=js"

import "./import-tradeindia.vue?vue&type=style&index=0&id=7f33a994&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f33a994"]])

export default __exports__